import { useTranslation } from 'react-i18next';

import React, { useRef, useState } from 'react';

import { AuthVariant } from './AuthBox';
import Button from '../../01_atoms/Button/Button';
import TextInput from '../../01_atoms/TextInput/TextInput';
import { Auth } from 'aws-amplify';
import useAuth from '../../../hooks/useAuth';
import {
  getAuthErrorMessage,
  waitForRequestConfirmation,
} from '../../../utils/authError';

type ConfirmAuthCodeProps = {
  confirmCode?: string;
  errorInformation: null | {
    position: string;
    element: React.ReactNode;
  };
  setCode: (v: string) => void;
  setCurrentVariant: (variant: AuthVariant) => void;
  setPassword: (v: string) => void;
  setIsLoading: (val: boolean) => void;
};

export default function ConfirmAuthCode({
  confirmCode,
  errorInformation,
  setCode,
  setIsLoading,
}: ConfirmAuthCodeProps) {
  const { t } = useTranslation();
  const { handleSignOut } = useAuth();
  const [isSending, setIsSending] = useState(false);
  const [sendError, setSendError] = useState('');
  const [sendMessage, setSendMessage] = useState('');
  const isSendingRef = useRef(false);

  const handleSendCode = async () => {
    if (isSendingRef.current) {
      return;
    }
    isSendingRef.current = true;
    setSendError('');
    setSendMessage('');
    setIsSending(true);
    setIsLoading(true);
    try {
      const status = await waitForRequestConfirmation(
        Auth.verifyCurrentUserAttribute('email'),
      );
      setSendMessage(
        status === 'confirmed'
          ? t('EMAIL_SENT')
          : t('EMAIL_DELIVERY_UNCONFIRMED'),
      );
    } catch (error) {
      setSendError(getAuthErrorMessage(t, error));
    } finally {
      isSendingRef.current = false;
      setIsSending(false);
      setIsLoading(false);
    }
  };
  return (
    <>
      <React.Fragment key="confirm-submit-fragment">
        <TextInput
          id="code"
          type="text"
          name="code"
          onChange={(e): void => {
            setCode(e.target.value);
          }}
          required
          placeholder={t('CODE_FROM_EMAIL')}
          defaultValue={confirmCode}
          error={
            errorInformation?.position === 'code' && errorInformation.element
          }
          style={{ marginTop: '3.5rem' }}
        />

        <Button
          type="submit"
          disabled={isSending}
          style={{
            cursor: 'pointer',
            display: 'block',
            marginTop: '3rem',
          }}
        >
          {t('BEST_TIGEN')}
        </Button>
        {sendError ? (
          <p role="alert" style={{ color: '#d33', marginTop: '0.75rem' }}>
            {sendError}
          </p>
        ) : null}
        {sendMessage ? <p role="status">{sendMessage}</p> : null}

        <Button
          onClick={handleSendCode}
          type="button"
          disabled={isSending}
          style={{
            cursor: 'pointer',
            display: 'block',
            marginTop: '1rem',
          }}
        >
          {t('SEND_CODE_AGAIN')}
        </Button>
        <Button
          type="button"
          onClick={() => handleSignOut()}
          variant="text"
          style={{
            cursor: 'pointer',
            display: 'block',
            marginTop: '1rem',
          }}
        >
          {t('AUSLOGGEN')}
        </Button>
      </React.Fragment>
    </>
  );
}
